import api from 'api/apiInstance';

export function clientsFollowAllApi(path: string) {
  return {
    path,
    POST: () => api.post(path),
  };
}
